<div
  class="context-menu-anchor k-button icon-button k-button-solid-base"
  role="button"
  [class.k-disabled]="disabled"
  #anchor
  (click)="gridWrapperComponent.openContextMenu(anchor, dataItem)"
>
  <fa-icon class="icon" size="xs" [icon]="faEllipsis"></fa-icon>
</div>
